import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { MealInput, MealInputProps } from '../ui/diary/MealInput';

let root: Root | null = null;

export interface MountOptions extends MealInputProps {}

export function mountMealInput(
  container: HTMLElement,
  options: MountOptions
): void {
  if (root) {
    root.unmount();
  }
  root = createRoot(container);
  root.render(<MealInput {...options} />);
}

export function unmountMealInput(): void {
  if (root) {
    root.unmount();
    root = null;
  }
}
